import React from 'react';
import { SettingsRow } from './SettingsRow';
import { ColourProperties, characterMappedCharacterSetModeSet, characterMappedCharacterSetAddressSet, selectCharacterSetInfo, characterMappedCharacterSetTargetSet } from '../../store/graphicsSlice';
import { EnumSetting } from './EnumSetting';
import { HexNumberInput } from './HexNumberInput';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { logMajorComponentRender } from '../../classes/Logger';
import { ColourSwatch } from './ColourSwatch';

export const CharacterSetAddressSettingsSection: React.FC = () => {
    logMajorComponentRender(CharacterSetAddressSettingsSection.name);

    const dispatch = useAppDispatch();
    const { viewLayout, address, target } = useAppSelector(selectCharacterSetInfo);

    const enabled = (viewLayout === 'CharacterMapped');
    const addressEnabled = enabled && target === 'Ram';

    return (
        <SettingsRow label='Charset'>
            <EnumSetting
                label="target"
                selectedOption={target}
                options={enabled ? { '$D000': 'RomA', '$D800': 'RomB', 'Ram': 'Ram' } : {}}
                order={['$D000', '$D800', 'Ram']}
                onChange={v => dispatch(characterMappedCharacterSetTargetSet(v))}
            />
            <HexNumberInput
                label={"address"}
                enabled={addressEnabled}
                number={address}
                onChange={n => dispatch(characterMappedCharacterSetAddressSet(n))}
                forceFourDigits={true}
                notifyFocus={true}
            />
        </SettingsRow>
    )
}

export const CharacterSetColoursSettingsSection: React.FC = () => {
    logMajorComponentRender(CharacterSetColoursSettingsSection.name);

    const { viewLayout, mode } = useAppSelector(selectCharacterSetInfo);

    const enabled = (viewLayout === 'CharacterMapped');

    const swatches: JSX.Element[] = [];

    if (mode === 'HiRes') {
        swatches.push(<ColourSwatch key='0' property={ColourProperties.CharacterMappedCharacterSetHiresBackground00} enabled={enabled} />)
        swatches.push(<ColourSwatch key='1' property={ColourProperties.CharacterMappedCharacterSetHiresForeground01} enabled={enabled} />);
    }

    if (mode === 'MultiColour') {
        swatches.push(<ColourSwatch key='00' property={ColourProperties.CharacterMappedCharacterSetMultiColourBackground00} enabled={enabled} />)
        swatches.push(<ColourSwatch key='01' property={ColourProperties.CharacterMappedCharacterSetMultiColourForeground01} enabled={enabled} />);
        swatches.push(<ColourSwatch key='10' property={ColourProperties.CharacterMappedCharacterSetMultiColourForeground10} enabled={enabled} />);
        swatches.push(<ColourSwatch key='11' property={ColourProperties.CharacterMappedCharacterSetMultiColourForeground11} enabled={enabled} />);
    }

    return (
        <SettingsRow label='Colours'>
            {swatches}
        </SettingsRow>
    );

}

export const CharacterSetModeSettingsSection: React.FC = () => {

    logMajorComponentRender(CharacterSetModeSettingsSection.name);

    const dispatch = useAppDispatch();
    const { viewLayout, mode } = useAppSelector(selectCharacterSetInfo);

    const enabled = (viewLayout === 'CharacterMapped');

    return (
        <SettingsRow label='Charset'>
            <EnumSetting
                label="mode"
                selectedOption={mode}
                options={enabled ? { 'hires': 'HiRes', 'multicol': 'MultiColour' } : {}}
                order={['hires', 'multicol']}
                onChange={v => dispatch(characterMappedCharacterSetModeSet(v))}
            />
        </SettingsRow>
    );
}